"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.setCookie = exports.buildOptionsString = void 0;
const validation_1 = require("./validation");
const _1 = require("./");
const parseCookieOptionName = (name) => name
    .replace(/([A-Z]{1})/g, "-$1")
    .replace(/^([a-z])/, (firstChar) => firstChar.toUpperCase());
const optionToString = (option) => option.toUTCString ? option.toUTCString() : option.toString();
const buildOptionsString = (options) => Object.entries(options)
    .reduce((acc, [key, value]) => {
    if (typeof value !== "undefined") {
        acc.push(`${parseCookieOptionName(key)}=${optionToString(value)}`);
    }
    return acc;
}, [])
    .join(";");
exports.buildOptionsString = buildOptionsString;
const setCookie = async (name, value, cookieOptions = {}, removeOnMissingConsent = false) => {
    if (!cookieOptions.expires && !cookieOptions.maxAge) {
        console.warn(`Cookie "${name}" will expire when the session ends.\nNo "expires" date or "maxAge" in the options.`);
    }
    const { isValid, errors } = (0, validation_1.validateOptions)(cookieOptions);
    if (!isValid) {
        throw new Error(`Error setting cookie. ${errors.join("\n")}`);
    }
    const canSetValue = await _1.CookieConsent.canSetValue(name);
    if (!canSetValue) {
        if (removeOnMissingConsent) {
            const path = cookieOptions.path || '/';
            const domain = cookieOptions.domain || "";
            document.cookie = name + `=; Path=${path};domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        }
        return false;
    }
    const optionsString = (0, exports.buildOptionsString)(cookieOptions);
    document.cookie = `${name}=${value};${optionsString}`;
    return true;
};
exports.setCookie = setCookie;
const getCookie = (name) => {
    const re = new RegExp(`(?:(?:^|.*;\\s*)${name}\\s*\\=\\s*([^;]*).*$)|^.*$`, "g");
    const value = document.cookie.replace(re, "$1");
    return value;
};
exports.getCookie = getCookie;
//# sourceMappingURL=cookie.js.map